/** @format */

import { Container } from "../../components/layouts/Container";
import BcartEconomicEstimateCheckElement from "../../components/ui_elements/bcart/Economic/EconomicEstimateCheckElement";

const BcartEconomicEstimateCheck = ({ redirect }: { redirect?: boolean }) => {
  return (
    <Container isLogin={true} background={"default"} align={"top"} redirect={redirect}>
      <BcartEconomicEstimateCheckElement redirect={redirect} />
    </Container>
  );
};

export default BcartEconomicEstimateCheck;
